export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filters"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apply"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear All"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Status"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Store"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter Invoice"])}
}